import Button from 'src/Components/Button/Button';
import Modal from 'src/Utils/CssModules/modal.module.css';
import './SubscriptionCancelDialog.css';

import AuraLaptop from "src/images/AuraLaptop.png";
import Cancel from "src/images/cancel.png";
import { formatSubscriptionEndDate } from 'src/Utils/SubscriptionDateFormatter/SubscriptionDateFormatter';
import { useTranslation } from 'react-i18next';
import PopupDialog from 'src/SharedComponents/PopupDialog/PopupDialog';

interface ISubscriptionCancelDialog{
    onClose: () => void;
    onCancel: () => void;
    licenseEndDate: string;
}


const SubscriptionCancelDialog: React.FC<ISubscriptionCancelDialog> = ({onClose, onCancel, licenseEndDate}) => {
    const { t } = useTranslation();

    return(
        <div className='cancel-subscription-container'>
            <PopupDialog onClose={onClose} popupWidth='440px'>
                <div className='row' style={{marginLeft: '12px'}}>
                    <div className={Modal.header} style={{ textAlign: 'center', paddingLeft: '0px', paddingTop: '30px' }}>
                        <div className='col image-container'>
                            <img src={AuraLaptop} alt="Aura" />
                            <img src={Cancel} alt="Cancel" className="cancel-icon" />
                        </div>

                        
                        <div className='col cancel-subscription'>
                            <span>{t('CancelSubscription')}</span>
                        </div>
                    </div>
                    <div className={Modal.body}>
                        <div className='row' style={{ paddingTop: '15px'}}>
                            <span style={{fontSize: '14px'}}>{t('CancelSubscriptionConfirmation')}</span>
                        </div>
                        <div className='row' style={{ paddingTop: '15px'}}>
                            <span style={{fontSize: '14px'}}>{t('AccessUntilWithDate', { licenseEndDate: formatSubscriptionEndDate(licenseEndDate) })}</span>
                        </div>
                        <div className='row' style={{ paddingTop: '15px'}}>
                            <span style={{fontSize: '14px'}}>{t('DataDeletionWarning')}</span>
                        </div>
                    </div>
                    <div className="row mb-5 mt-4 btnAlign">
                            <Button
                                backgroundColor='rgba(255, 15, 0, 1)'
                                color='#fff'
                                testId='close'
                                onClick={onCancel}
                                text={t('CancelSubscription')}
                                width='50%'
                                height='48px'
                                borderRadius='24px'
                                borderColor="none" />
                    </div>
                </div>
            </PopupDialog>
        </div>
    );
}

export default SubscriptionCancelDialog;